import { trpc } from '@/lib/trpc'

/** Optionale, kundenspezifische Module (Einstellungen → Module). Standard: aus. */
export function useFeatures() {
  const q = trpc.features.get.useQuery(undefined, { retry: false, staleTime: 60_000 })
  return {
    expensesEnabled: q.data?.expensesEnabled ?? false,
    /** Modul an UND Benutzer darf Finanzdaten sehen (Inhaber/Admin) */
    expensesVisible: q.data?.expensesVisible ?? false,
    loading: q.isLoading,
  }
}
